import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [currencies, setCurrencies] = useState(["USD"]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/currencies").then(({ data }) => setCurrencies(data.map((c) => c.code))).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ name, email, password, base_currency: currency });
      toast.success("Welcome to CampusCash!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <div className="w-9 h-9 bg-violet-300 border-2 border-black rounded-lg flex items-center justify-center brutal-shadow-sm">
            <span className="font-outfit font-black">C</span>
          </div>
          <span className="font-outfit font-black text-xl">CampusCash</span>
        </Link>

        <div className="brutal-card p-8">
          <h1 className="font-outfit font-black text-4xl mb-2">Start free.</h1>
          <p className="font-manrope text-black/60 mb-8">Takes 30 seconds. No card needed.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Name</label>
              <input value={name} onChange={(e) => setName(e.target.value)} required
                className="brutal-input" placeholder="Alex Chen" data-testid="register-name-input" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="brutal-input" placeholder="you@college.edu" data-testid="register-email-input" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                className="brutal-input" placeholder="At least 6 characters" data-testid="register-password-input" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Base currency</label>
              <select value={currency} onChange={(e) => setCurrency(e.target.value)}
                className="brutal-input" data-testid="register-currency-select">
                {currencies.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <button type="submit" disabled={loading}
              className="brutal-btn bg-violet-300 hover:bg-violet-400 w-full py-3 disabled:opacity-50"
              data-testid="register-submit-btn">
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>

          <p className="mt-6 text-sm font-manrope text-black/60 text-center">
            Already have an account?{" "}
            <Link to="/login" className="font-bold underline underline-offset-4" data-testid="go-to-login-link">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
